// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"14c52bd3","646":"14c52bd3","792":"14c52bd3","926":"14c52bd3"}[chunkId] + ".chunk.css";
};